import AssignmentModel from '@/dex-shared/models/AssignmentModel';

export default {
  assignmentById: (state: any, getters: any) => (assignmentId: number) => {
    let assignment = state.assignments[assignmentId];
    if (assignment) {
      return new AssignmentModel(assignment, getters);
    } else {
      return null;
    }
  },
};
